import React from 'react';
import { FiGrid, FiUsers, FiBookOpen, FiActivity, FiBox } from 'react-icons/fi';

export type NavItem = {
  path: string;
  label: string;
  icon: React.ReactNode;
  group: 'Overview' | 'Users' | 'Moonrock';
  securityGroup: 'admin_portal' | 'resourceHub_form';
  description?: string;
};

// Leads and matches moved to TutorForge, and content is published directly, so the dashboard is
// for users and activity only.
export const NAV_ITEMS: NavItem[] = [
  { path: '/admin', label: 'Overview', icon: <FiGrid />, group: 'Overview', securityGroup: 'admin_portal' },
  { path: '/admin/worksheetsUsers', label: 'Worksheet users', icon: <FiUsers />, group: 'Users', securityGroup: 'admin_portal' },
  { path: '/admin/readingPortalUsers', label: 'Reading users', icon: <FiBookOpen />, group: 'Users', securityGroup: 'admin_portal' },
  {
    path: '/admin/moonrock',
    label: 'Moonrock',
    icon: <FiActivity />,
    group: 'Moonrock',
    securityGroup: 'admin_portal',
    description: 'Player analytics for the Moonrock language game.',
  },
  {
    path: '/admin/moonrock/assets',
    label: 'Game Assets',
    icon: <FiBox />,
    group: 'Moonrock',
    securityGroup: 'admin_portal',
    description: 'Browse Lunas, producers, merge items, and build pieces.',
  },
];

export const NAV_GROUPS: NavItem['group'][] = ['Overview', 'Users', 'Moonrock'];

export const findNavItem = (pathname: string): NavItem | undefined =>
  NAV_ITEMS.find((item) => item.path === pathname.replace(/\/$/, ''));
